import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep" data-id="element-80" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-81" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl uppercase tracking-wide text-gold" data-id="element-82" data-mp="3ghc2o28413o8">
          Cheer Coach Pro™
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-83" data-mp="36pftnw4hjt58">
          The Open &amp; Coach System™ — because coaching cheer shouldn&apos;t
          cost you every evening of the week.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-84" data-mp="38h5b9u0hiky">
          <a href="mailto:[SUPPORT_EMAIL]" className="hover:text-white hover:underline" data-id="element-85" data-mp="3lelybzm3ebki">
            [SUPPORT_EMAIL]
          </a>
          <a href="[INSTAGRAM_URL]" className="hover:text-white hover:underline" data-id="element-86" data-mp="3qfjhofiu9bnl">
            [@handle]
          </a>
          <a href="[SITE_URL]" className="hover:text-white hover:underline" data-id="element-87" data-mp="2eya1c1v0azqi">
            [www.site.com]
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-navy-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-88" data-mp="3l8qxu8j60rtk">
          Cheer Coach Pro is an educational resource for coaches. It does not
          replace coach certification, CPR/first-aid training, or the current
          rules of NFHS, USASF or your school, gym or league. Coaches are
          responsible for verifying that any skill is trained, supervised,
          age-appropriate and legal in their setting before it is performed.
          © Cheer Coach Pro™ 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}